import { FormDetails, FormResponseDetails } from '@shared/models/form/form.model';
import { stripInlineAssetData } from '@shared/utilities/form-attachment-ref.util';
import { StaticServiceRequestFormResponse } from '@features/service/pages/service-request-form-page/service-request-form-response.mapper.util';

function isStaticOfflineSnapshot(
  snapshot: FormDetails | FormResponseDetails | StaticServiceRequestFormResponse,
): snapshot is StaticServiceRequestFormResponse {
  return Array.isArray((snapshot as StaticServiceRequestFormResponse).answers);
}

/** Build refs-only optimistic `responseJson` for offline context cache (no base64). */
export function buildOptimisticOfflineResponseJson(
  snapshot: FormDetails | FormResponseDetails | StaticServiceRequestFormResponse,
  mode: 'create' | 'edit',
): string {
  if (isStaticOfflineSnapshot(snapshot)) {
    return JSON.stringify({
      ...snapshot,
      answers: (snapshot.answers ?? []).map((answer) => stripInlineAssetData(answer)),
    });
  }

  const formSnapshot = snapshot as FormDetails | FormResponseDetails;
  const questions = (formSnapshot.formQuestions ?? []).map((question) => stripInlineAssetData({
    questionId: question.formQuestionId,
    responseQuestionId: question.responseQuestionId,
    answer: question.answer,
    assets: question.assets,
    type: question.formQuestionType,
    label: question.formQuestionLabel,
    sequence: question.formQuestionSequence,
    isRequired: question.formQuestionRequired,
  }));

  if (mode === 'edit') {
    return JSON.stringify({
      responseId: (formSnapshot as FormResponseDetails).responseId,
      questions,
    });
  }

  return JSON.stringify({
    formId: formSnapshot.formId,
    questions,
  });
}
